 <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.add_reports' | translate }} </h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text">{{ 'MENU.DASHBOARD.add_reports_list' | translate }}</p>
          </div>
        </div>


<div class="card">
  <div class="card-body">
   <form #contractForm="ngForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
  <div class="row">

<!-- PDF Upload -->
<div class="col-md-12 mt-2">
  <label class="form-label">
    {{ 'MENU.DASHBOARD.pdf' | translate }}
  </label>
  <input
    type="file"
    accept=".pdf"
    (change)="onPdfSelected($event)"
    class="form-control"
  />
</div>

     <!-- Title -->
  <div class="col-md-12">
    <div class="mb-3">
      <label class="form-label required-field">
        {{ 'MENU.DASHBOARD.title' | translate }}
      </label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="formData.title"
        name="title"
        #title="ngModel"
        required
        [class.is-invalid]="title.invalid && title.touched"
      />
      <div *ngIf="title.invalid && title.touched" class="text-danger small mt-1">
        {{ 'MENU.DASHBOARD.title' | translate }}
      </div>
    </div>
  </div>

 
  </div>

  <!-- Submit -->
  <div class="row">
    <div class="col-sm-4">
      <div class="mb-3 d-flex justify-content-start">
        <button
          type="submit"
          class="btn"
          [disabled]="contractForm.invalid"
          style="background-color: #cca44c !important; color: #fff;"
        >
          {{ 'MENU.DASHBOARD.add' | translate }}
        </button>
      </div>
    </div>
  </div>
</form>

  </div>
</div>
